import { useState } from "react";
import { Mail, ShieldCheck } from "lucide-react";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import axios, { API, formatApiError } from "@/lib/apiClient";
import { toast } from "sonner";

export const EmailGateModal = ({ auditId, onUnlocked }) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await axios.post(`${API}/audits/${auditId}/unlock`, { email });
      toast.success("Pulse Check unlocked.");
      onUnlocked(email);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 p-4" data-testid="email-gate-modal">
      <div className="w-full max-w-md rounded-lg border border-surface-border bg-surface-card p-8 fade-up glow-sovereign">
        <div className="mb-4 flex items-center gap-2 text-sovereign">
          <ShieldCheck className="h-5 w-5" />
          <span className="text-xs font-bold uppercase tracking-widest">Scan Complete</span>
        </div>
        <h2 className="mb-2 font-heading text-2xl font-bold text-white">Your Pulse Check is ready.</h2>
        <p className="mb-6 text-sm text-slate-400">
          Enter your email to unlock your free Visibility Score and see exactly where AI models are hallucinating about your brand.
        </p>
        <form onSubmit={submit} className="space-y-3">
          <div className="relative">
            <Mail className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-500" />
            <Input
              type="email"
              required
              placeholder="you@brand.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="border-surface-border bg-obsidian pl-9 text-white"
              data-testid="lead-email-input"
            />
          </div>
          {error && <p className="text-sm text-sovereign" data-testid="email-gate-error">{error}</p>}
          <Button type="submit" disabled={loading} className="w-full bg-sovereign text-white hover:bg-sovereign/90" data-testid="unlock-pulse-check-btn">
            {loading ? "Unlocking..." : "Reveal My Pulse Check"}
          </Button>
        </form>
      </div>
    </div>
  );
};
